import PropTypes from "prop-types";
import ProductDiscount from "../../ProductDiscount";
import ProductSponsored from "../../ProductSponsored";
import styles from "./index.css";

const Banners = ({ discount, isSponsored }) => (
  <>
    {discount !== null && (
      <ProductDiscount discount={discount} className={styles.productDiscount} />
    )}
    {isSponsored && <ProductSponsored className={styles.productSponsored} />}
  </>
);

Banners.propTypes = {
  discount: PropTypes.number,
  isSponsored: PropTypes.bool
};

export default Banners;
